import { type FieldProps } from 'formik';
import React from 'react';
import { TextInput } from '../..';
import { TextInputProps } from '../TextInput';

type FormikTextInputProps = FieldProps & TextInputProps;

export const FormikTextInput = ({
  field,
  form: { touched, errors, values},
  ...props
}: FormikTextInputProps): React.JSX.Element => {
  const fieldName = field.name;
  const error: string = typeof errors[fieldName] === 'string' && errors[fieldName];
  return (
      <TextInput 
        touched={!!touched[fieldName]}
        error={error}
        value={values.fieldName}
        {...field}
        {...props}
      />
  );
};

export default FormikTextInput;